
import WheelBonusResult from "integration/results/wheel-bonus-result";
import revolverModel from "slotworks/integration/revolver/model/revolver-model";
import { Eval, FreespinUpdate, State, User } from "slotworks/integration/revolver/schema/spin-record-schema";
import Record from "slotworks/model/gameplay/records/record";
import Result from "slotworks/model/gameplay/records/results/result";
import { ResultBuilder } from "slotworks/server/builders/result-builder";

class WheelBonusResultBuilder implements ResultBuilder {

    public bonusId: string;
    public triggerAliases: string[];

    public filter(data: any): boolean {
        let spinResponse: SpinResponseSchema;

        if (data) {
            spinResponse = data as SpinResponseSchema;
        }

        return spinResponse && 
                spinResponse.RESULTS !== undefined &&
                spinResponse.RESULTS.next_game === "WHEEL_BONUS";
    }

    public build(record: Record, data: any): Result[] {
        let spinResponse: SpinResponseSchema;

        if (data) {
            spinResponse = data as SpinResponseSchema;
        }

        const bonusResult = new WheelBonusResult();
        bonusResult.total = spinResponse.RESULTS.next_game_state.total;
        bonusResult.remain = spinResponse.RESULTS.next_game_state.remain;

        return [bonusResult];
    }
}

export default new WheelBonusResultBuilder();

export interface SpinResponseSchema {
    RESULTS: Results;
    USER: User;
    time: number;
}

export interface Results {
    additionalData: any;
    eval: Eval;
    game: string;
    next_game: string;
    games_pending: boolean;
    round_id: number;
    total_bet_cash: number;
    total_win_cash: number;
    state: State;
    updated_free_spin_campaign_details: FreespinUpdate;
    next_game_state: NextGameState;
}

export interface NextGameState {
    buyoutGame: boolean;
    game: string;
    total: number;
    total_win_cash: number;
    spin_pending: boolean;
    is_complete: boolean;
    remain: number;
}